/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const engagementStats = pickLocale(ar.engagementStats, en.engagementStats)
export const awarenessStrings = pickLocale(ar.awarenessStrings, en.awarenessStrings)
export const policiesStrings = pickLocale(ar.policiesStrings, en.policiesStrings)
export const surveysStrings = pickLocale(ar.surveysStrings, en.surveysStrings)
export const assessmentsStrings = pickLocale(ar.assessmentsStrings, en.assessmentsStrings)
